import {
  Dumbbell,
  HeartPulse,
  Activity,
  Target,
  Sparkles,
  LineChart,
  GraduationCap,
  Crown,
} from "lucide-react";

const items = [
  {
    icon: <Target className="w-5 h-5" />,
    title: "Sport-Performance Training",
    text: "Track & Field, Boxing, Basketball — programmed by sport science principles.",
  },
  {
    icon: <Dumbbell className="w-5 h-5" />,
    title: "Strength & Conditioning",
    text: "Strength, hypertrophy, power, and athletic development — periodized.",
  },
  {
    icon: <HeartPulse className="w-5 h-5" />,
    title: "General Fitness",
    text: "Fat loss, muscle tone, healthy movement for everyday athletes.",
  },
  {
    icon: <Activity className="w-5 h-5" />,
    title: "Readiness-Based Modifications",
    text: "Workouts adapt to fatigue, soreness, sleep, energy, stress and pain.",
  },
  {
    icon: <Sparkles className="w-5 h-5" />,
    title: "Mobility & Recovery",
    text: "Dedicated mobility flows and recovery sessions inside every plan.",
  },
  {
    icon: <LineChart className="w-5 h-5" />,
    title: "Progress Tracking",
    text: "Logs, performance tests, and personal records — at a glance.",
  },
  {
    icon: <GraduationCap className="w-5 h-5" />,
    title: "Exercise Guidance",
    text: "Cues, demos, and coaching notes for every movement in the library.",
  },
  {
    icon: <Crown className="w-5 h-5" />,
    title: "Premium & Elite Paths",
    text: "Two tiers — from structured fitness to elite athlete programming.",
  },
];

export default function SolutionSection() {
  return (
    <section
      id="solution"
      className="relative nfp-section bg-[#0a0a0a]"
      data-testid="section-solution"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#1FA2FF] mb-4">
              The Solution
            </p>
            <h2 className="nfp-heading text-white text-4xl md:text-6xl leading-[1] tracking-tight">
              One app. <br />
              Programmed for your <span className="text-[#00E5FF]">goal</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/65 text-base md:text-lg leading-relaxed">
            NFP delivers structured training programs built around your sport,
            level, and training needs — backed by a 250+ program library and
            200+ exercise library, with an AI Coach in your pocket.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {items.map((it, i) => (
            <div
              key={it.title}
              className="nfp-card p-6 group"
              data-testid={`solution-card-${i}`}
            >
              <div className="w-10 h-10 rounded-lg bg-[#1FA2FF]/10 border border-[#1FA2FF]/30 text-[#00E5FF] flex items-center justify-center group-hover:bg-[#1FA2FF]/20 transition-colors">
                {it.icon}
              </div>
              <h3 className="mt-4 text-white text-lg font-semibold tracking-tight">
                {it.title}
              </h3>
              <p className="mt-1.5 text-sm text-white/55 leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
